<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/Agent')">公司代理</a></p>
        </div>
    </div>
    <div class="agent-zhu">
        <h3>公司代理</h3>
        <div class="agent-body">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="评 级 授 权 代 理 商" >
                    <el-table-column prop="name" label="公司" width="180px"/>
                    <el-table-column prop="realName" label="负责人" width="80px"/>
                    <el-table-column prop="address" label="地址" fit/>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            tableData: [
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                },
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                },
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                },
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                },
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
                ,
                {
                    name: 'Tom',
                    realName: 'Tom',
                    address: 'No. 189, Grove St, Los Angeles',
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1225px) {
            width: 100%;
        }
        
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}

.agent-zhu {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    h3 {
        @media only screen and (max-width: 810px) {
            width: 90%;
            margin: 20px 5%;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
        }
    }
    .agent-body {
        padding-left: 94px;
        @media only screen and (max-width: 1300px) {
            padding: 0 4%;
        }
        @media only screen and (max-width: 735px) {
            padding: 0 1%;
        }
    }
}
</style>